$('#contact-form').submit(function (e) {
    e.preventDefault();

    var phone = $('#contact-form').find('[name="phone"]');
    var name = $('#contact-form').find('[name="name"]');
    var email = $('#contact-form').find('[name="email"]');
    var comment = $('#contact-form').find('[name="comment"]');

    var data = {
        phone: phone.val(),
        name: name.val(),
        email: email.val(),
        comment: comment.val()
    };

    $.ajax({
        type: $('#contact-form').attr('method'),
        url: $('#contact-form').attr('action'),
        data: data,
        success: function (response) {
            if (response.result === 'success') {
                phone.val('');
                name.val('');
                email.val('');
                comment.val('');
                $('#success-alert').show();

                setTimeout(function() {
                    $('#success-alert').hide();
                }, 5000);
            } else {
                $('#error-alert').show();
                setTimeout(function() {
                    $('#error-alert').hide();
                }, 5000);
            }
        },
        error: function (response) {
            $('#error-alert').show();
            setTimeout(function() {
                $('#error-alert').hide();
            }, 5000);
        }
    });
});
